'use strict';

var GetIntrinsic = require('../GetIntrinsic');

var $test = GetIntrinsic('RegExp.prototype.test');

var callBind = require('./callBind');

module.exports = function regexTester(regex) {
	return callBind($test, regex);
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/regexTester.js
// module id = 1111
// module chunks = 1